<template>
	<div class="bind-wx" :loading="loading">
		<el-dialog :visible.sync="showDialog"
			title="绑定微信"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:append-to-body="true"
			width="500px"
			top="70px"
			@close="handleClose">
			<template v-if="wxinfo">

				<div style="margin-bottom: 8px;cursor: pointer;">
					<el-popover
						placement="top-start"
						title=""
						width=""
						trigger="hover"
						content="">
						<img src="../../assets/img/official.jpg" alt="">
						<p slot="reference">提示：请先关注【心理亦笙<i class="el-icon-s-opportunity shining-icon"></i>】公众号，否则收不到微信消息推送</p>
					</el-popover>
				</div>
				<div class="wxinfo-div">
					<span>当前绑定微信：</span>
					<el-avatar shape="square" :size="50" :src="wxinfo.headimgurl"></el-avatar>
					<span>{{wxinfo.nickname}}</span>
				</div>
			</template>
			<!-- 重新绑定二维码 -->
			<template v-if="qrcode_url">
				<div class="qrcode-div">
					<el-divider>请使用微信扫描下方二维码</el-divider>
					<vue-qr :text="qrcode_url" :size="180"></vue-qr>
					<!-- 扫描成功遮罩 -->
					<div class="success-wrap" v-if="qrcode_status != 0">
						<div class="success" v-show="qrcode_status == 1">
							<p class="sub-til">扫描成功</p>
							<p class="code-tips">请在手机上［确认绑定］</p>
							<p class="tip-text">
								<a href="javascript:void(0);" class="blue" @click="showQrcode">返回二维码</a><br>
							</p>
						</div>

						<!-- 失效开始 -->
						<div class="efficacy" v-show="qrcode_status == 2">
							<p class="text">二维码失效</p>
							<a href="javascript:void(0);" class="efficacy-btn" @click="showQrcode">点击刷新</a>
						</div>
						<!-- 失效结束 -->
					</div>
				</div>
			</template>

			<template slot="footer">
				<el-button type="primary" @click="showQrcode">获取二维码</el-button>
			</template>
		</el-dialog>

	</div>
</template>

<script>
  import base from '@/api/common';
  import vueQr from 'vue-qr';

  export default {
    name: "BindWx",
    components: {vueQr},
    data() {
      return {
        loading: false,
        showDialog: false,

        wxinfo: null,// 微信用户信息

        qrcode_interval: null,// 轮询二维码状态任务
        qrcode_url: null,// 绑定二维码地址
        qrcode_status: 0,// 二维码状态
      }
    },
    methods: {
      async show() {
        let vm = this;
        // 查找当前是否有绑定微信
        await this.$ajax.post(base.api.wechat.isBind)
          .then((res) => {
            if (res.data.status == "success") {
              if (res.data.data) {
                this.wxinfo = res.data.data;
              } else {
                this.showQrcode();
              }
            }
            vm.showDialog = true;
          });
      },
      // 生成绑定二维码，轮询二维码扫描状态
      async showQrcode() {
        let vm = this;
        let params = {
          type: 'bind'
        }
        await this.$ajax.post(base.api.wechat.qrcode, params)
          .then((res) => {
            if (res.data.status == "success") {
              vm.qrcode_url = res.data.data.qrcode;
              vm.qrcode_status = 0;
              vm.rk = res.data.data.rk;
              // 只允许存在一个timer
              if(vm.qrcode_interval){
                clearInterval(vm.qrcode_interval);
              }
              vm.qrcode_interval = setInterval(vm.checkQrcode, 1000);
            }
          });
      },
      checkQrcode() {
        let vm = this;
        this.$ajax.post(base.api.wechat.qrcode_status + '?redisKey=' + vm.rk)
          .then((res) => {
            if (res.data.status == "success") {
              if (res.data.data == 'scaned') {
                vm.qrcode_status = 1;
              } else if (res.data.data == 'success') {// 绑定成功
                vm.qrcode_url = 0;
                vm.show();
              }
            } else if (res.data.status == "fail") {
              vm.qrcode_status = 2;
            }
          })
      },
      handleClose() {
        this.showDialog = false;
        window.clearInterval(this.qrcode_interval);
      },

    },
    beforeDestroy() {
      window.clearInterval(this.qrcode_interval);
    }
  }
</script>

<style scoped lang="scss">
	.wxinfo-div {
		display: flex;
		align-items: center;
		justify-content: center;

		.el-avatar {
			box-shadow: 0 0 3px 3px #efeeee;
			margin-right: 10px;
		}

	}

	.qrcode-div {
		text-align: center;
		position: relative;

		.success-wrap {
			position: absolute;
			top: 22px;
			left: 50%;
			transform: translateX(-50%);
			text-align: center;
			width: 180px;
			height: 180px;
			background-color: rgba(195, 195, 195, 0.9);

			.success-img {
				margin-top: 30px;
			}

			.sub-til {
				font-size: 24px;
				line-height: 34px;
				margin-top: 45px;
				color: #333;
			}

			.code-tips {
				color: #666;
				margin-top: 10px;
			}

			.tip-text {
				color: #333;
				line-height: 26px;
			}

			.efficacy {
				margin-top: 35%;
			}
		}
	}


	.shining-icon{
		vertical-align: super;
		animation: shining 2s ease infinite;
	}

	@keyframes shining {
		0% {
			color: #56C147;
		}
		20% {
			color: #3D65F4;
		}
		60% {
			color: #F2404A;
		}
		80% {
			color: darkorange;
		}
		to {
			color: #56C147;
		}
	}

</style>
